import { createModelId } from "@core/foundation/model";
import type { z } from "@core/zod";

import { ID_PREFIX } from "../../shared/id-prefix.ts";

const {
  generateDeterministicId: generateServiceId,
  getDigestFromId: getDigestFromServiceId,
  idSchema: ServiceIdSchema,
} = createModelId({ idPrefix: ID_PREFIX.SERVICE });

export { ServiceIdSchema, generateServiceId };

export type ServiceId = z.infer<typeof ServiceIdSchema>;

export function getServiceName(id: ServiceId): string {
  if (id.includes("-")) {
    throw new Error(`Unexpected hyphens in id "${id}"`);
  }

  const digest = getDigestFromServiceId(id);
  const hyphenated = digest.replaceAll("_", "-");

  return `${hyphenated}-service`;
}
